export const GlobalSearchDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GlobalSearch' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchArgsWhere' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '20' },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'referrer' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchOrderByInput' } },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'modifiers' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchArgsModifiers' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlobalSearchUsersQuery' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlobalSearchTeamsQuery' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'search' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'query' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'modifiers' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'modifiers' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'referrer' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'referrer' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalHitsCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'results' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'categoryId' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'createdByUser' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'meta' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'highlight' } }],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchResultDocument' } },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentType' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentDocumentType' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentMaterialAgreement' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentTerminationDate' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentNoticeDate' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentDateSigned' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentActive' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentEsigningStatus' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentIsSharedExternally' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentAutomaticRenewal' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentContractOwner' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentCountry' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentCurrency' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentDeviateFromStandard' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentGoverningLaw' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentNotes' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentNoticePeriodMonths' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentOriginalTermMonths' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentRenewalTermMonths' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentTotalContractCost' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentTotalContractValue' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentStartDate' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentProcessingOfPersonalData' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentOriginalVersionStored' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentOutsourcing' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentDocumentCategory' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentNoticePeriodDays' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentStatus' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentDiscount' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentFeeAdjustmentClause' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentIndemnity' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentLiabilityCap' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentLiabilityCapScope' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentLimitationOfLiability' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentPaymentTermsDaysFromInvoiceDate' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentPostTerminationObligations' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentProbationaryPeriod' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentProbationaryPeriodExpirationDate' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentTerminationForCause' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentTerminationForConvenience' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentParties' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentProjectIds' } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchResultTemplate' } },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataTemplateTitle' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'marketLocaleCode' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchResultProject' } },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataProjectCustomerId' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataProjectDocumentsCount' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataProjectMembersTeamIds' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataProjectMembersUserIds' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataProjectMembersCombinedUserIds' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataProjectStatus' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataProjectContractTerm' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataProjectProjectOwner' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlobalSearchUsersQuery' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'users' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order_by' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'name' },
                                                    value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlobalSearchTeamsQuery' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teams' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
